import React, { useState } from 'react';

import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Profile } from 'types/profile.types';

interface PhotoCellProps {
  photos: Profile['photos'];
}

const MEDIA_BASE_URL = process.env.REACT_APP_MEDIA_BASE_URL;

// Renders fixed-size photo thumbnails; clicking one opens a full-size preview dialog.
export const PhotoCell: React.FC<PhotoCellProps> = ({ photos }) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  return (
    <>
      <div className="flex gap-1">
        {photos.map((photo, index) => {
          const url = `${MEDIA_BASE_URL}${photo.url}`;
          return (
            <button
              key={index}
              type="button"
              onClick={() => setPreviewUrl(url)}
              className="size-12 shrink-0 overflow-hidden rounded-md border transition-opacity hover:opacity-80"
              aria-label="Open photo preview">
              <img src={url} alt="" className="size-full object-cover" />
            </button>
          );
        })}
      </div>

      <Dialog open={previewUrl !== null} onOpenChange={(open) => !open && setPreviewUrl(null)}>
        <DialogContent className="max-w-3xl">
          <DialogTitle className="sr-only">Photo preview</DialogTitle>
          {previewUrl && (
            <img
              src={previewUrl}
              alt=""
              className="max-h-[80vh] w-full rounded-md object-contain"
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
